module.exports = __webpack_public_path__ + "img/icon-index-usdt.b878da7d.svg";